import { environment } from "src/environments/environment";

export function getPublicFileSrcById(
  fileId: string | undefined,
  options: {
    noCache?: boolean;
    useFallback?: boolean;
  } = {
    noCache: false,
    useFallback: false
  }
): string | undefined {
  const { noCache, useFallback } = options;

  const fallbackFile: string = "/assets/images/fallback/facility.png";

  let srcFile: string | undefined = useFallback ? fallbackFile : undefined;

  if (!!fileId) {
    srcFile = `${environment.snoots.api.storage}/public/files/${fileId}`;

    if (noCache) {
      srcFile = `${srcFile}?nocache=${new Date().getTime()}`;
    }
  }

  return srcFile;
}
